import { useAppStore } from '@/store/useAppStore.ts'
import { ScrubInput } from 'calc-controls'

export function QuickMode() {
  const battery = useAppStore((s) => s.battery)
  const load = useAppStore((s) => s.load)
  const runtimeResult = useAppStore((s) => s.runtimeResult)
  const updateBattery = useAppStore((s) => s.updateBattery)
  const updateLoad = useAppStore((s) => s.updateLoad)
  const computeAll = useAppStore((s) => s.computeAll)
  const toggleQuickMode = useAppStore((s) => s.toggleQuickMode)

  const mainLoad = load.loads[0]
  const handleCapacityChange = (value: number) => {
    updateBattery('capacityValue', value)
    computeAll()
  }

  const handleLoadChange = (value: number) => {
    if (mainLoad) {
      updateLoad(mainLoad.id, { loadValue: value })
      computeAll()
    }
  }

  return (
    <div className="quick-mode">
      <div className="quick-mode__header">
        <h2 className="quick-mode__title">Quick Calculate</h2>
        <button type="button" className="quick-mode__exit" onClick={toggleQuickMode} aria-label="Exit quick mode">
          Full Mode →
        </button>
      </div>

      <ScrubInput
        label="Capacity"
        value={battery.capacityValue || 0}
        onChange={handleCapacityChange}
        unit="Ah"
        min={0}
        step={1}
        decimals={0}
      />

      <ScrubInput
        label="Load"
        value={mainLoad?.loadValue || 0}
        onChange={handleLoadChange}
        unit="A"
        min={0}
        step={0.1}
        decimals={1}
      />

      {runtimeResult && (
        <div className="quick-mode__result">
          <div className="quick-mode__runtime" role="status" aria-live="polite">
            <span className="quick-mode__runtime-label">Runtime</span>
            <span className="quick-mode__runtime-value">{runtimeResult.runtimeFormatted}</span>
          </div>
          <div className="quick-mode__detail">
            <span>{battery.voltage}V · {runtimeResult.effectiveCapacityAh.toFixed(1)}Ah effective</span>
          </div>
        </div>
      )}
    </div>
  )
}
